import React from 'react';

export default function Field({ label, value, onChange, type = 'text', disabled = false, placeholder = '', className = '' }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <input
        type={type}
        value={value || ''}
        onChange={e => onChange && onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        className={`w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 transition-shadow ${
          disabled ? 'bg-gray-50' : ''
        } ${className || 'px-4 py-3 text-base'}`}
      />
    </div>
  );
}

